module.exports = __webpack_public_path__ + "static/media/SvgSharePurpose.b1e08d4d.svg";